"use strict";

export const nav = function() {

    let scroll_pos = 0;

    function scrollTop() {
        return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }

    function toggleModal() {
        const is_open = document.documentElement.classList.contains('has_open_nav');
        // console.log( is_open );

        if( is_open ) {
            // ... then lets close the modal
            // console.log('Modal is open, lets close it');

            // remove the class to trigger the appropriate css
            document.documentElement.classList.remove('has_open_nav');

            // set the window scroll position to the saved value
            window.scroll(0, scroll_pos);
        } else {
            // ... then lets open the modal
            // console.log('Modal is closed, lets open it');

            // Set body's top position based on current scroll position. Otherwise page will jump to top.
            scroll_pos = scrollTop();
            // console.log('opening - top = ' + scroll_pos);
            document.body.style.top = -1 * scroll_pos + 'px';

            document.documentElement.classList.add('has_open_nav');
        }
    }

    const init = function() {
        const parent_items = document.querySelectorAll('.menu-item-has-children');

        // If any parent item is clicked, toggle the child items
        Array.prototype.forEach.call(parent_items, (el) => {
            el.querySelector('a').addEventListener('click', (ev) => {
                ev.preventDefault();
                el.classList.toggle('current-page-ancestor');
            }, false);
        });

        // Toggle offscreen menu
        const toggle = document.querySelector('.js-menu-toggle');
        toggle.addEventListener('click', (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            // console.log('---- toggle clicked');
            toggleModal();
        }, false);

        // Click scrim to close nav modal
        const scrim = document.querySelector('.js-scrim');
        scrim.addEventListener('click', (ev) => {
            // console.log('---- scrim clicked');
            toggleModal();
        }, false);

    };

    return { init };

}();